function createAction(type, payload = {}, meta) {
	return { type, payload, meta };
}

export const createUiActionType = type => `zender/STUDIO/UI/${type}`;

export const createUiAction = (type, payload, meta) => createAction(type, payload, meta);



// WEBPACK FOOTER //
// ./src/actions/util.js